import { useState } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { useSuspenseQuery } from '@apollo/client';
import { LocationListingsQuery } from '@/query';
import { IconButton } from '@/component/IconButton/IconButton';

import { Page } from './Page';

export const List = ({ group, variables }) => {
  const t = useTranslations();
  const locale = useLocale();
  const [pageCount, setPageCount] = useState(2);

  const { data } = useSuspenseQuery(LocationListingsQuery, {
    variables: {
      ...variables,
      locale,
      page: 1,
    },
    errorPolicy: 'ignore',
  });

  const totalPages = data?.availableListings?.metadata?.totalPages || 0;
  const pages = Array(pageCount - 1).keys();

  return totalPages > 1 ? (
    <>
      <section
        className={`container px-0 flex flex-col max-sm:pt-7 max-sm:pb-10 pb-16 min-h-full flex-1 3xl:mt-3 3xl:rounded-10`}
      >
        {[...pages].map((page) => (
          <Page
            key={page}
            group={group}
            page={page + 2}
            variables={variables}
          />
        ))}
        {totalPages > pageCount && (
          <div className="container">
            <IconButton
              className="btn btn-second self-start"
              onClick={() => setPageCount(pageCount + 1)}
            >
              {t('destinations.list.more')}
            </IconButton>
          </div>
        )}
      </section>
    </>
  ) : null;
};
